import React from "react";

import GeneralAccessManagement from "scenes/employees/GeneralAccess";
import SearchViewManagement from "scenes/search/View";
import { useSelector } from "react-redux";

// Import utilities
import { isAllowedToDoByKey } from 'permissions-hub';
import {
  EMPLOYEE_MANAGEMENT,
  DESIGNATION_MANAGEMENT,
  TEAM_MANAGEMENT,
  SHIFT_MANAGEMENT,
  ROLE_MANAGEMENT,
  ACCEPTED_PERMISSIONS,
} from "constants";
import { getAllowedPermissions, isAuthenticatedRoleAdmin, isAuthenticatedRoleTeamWise, } from "utils/authentication";

import WarningAlert from "common/Alert";

const SearchManagement = () => {
  
  const { userInfo: loggedUserInfo } = useSelector((state) => state.auth);

  const isRoleAdmin = isAuthenticatedRoleAdmin( loggedUserInfo );

  const isRoleTeamWise = isAuthenticatedRoleTeamWise( loggedUserInfo );

  // ?? Check 'Read' permission of designation, team, shift & role management.

  // Check read permission of designation
  const isAllowedToReadDesignation = isAllowedToDoByKey(
    DESIGNATION_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadTeam = isAllowedToDoByKey(
    TEAM_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadShift = isAllowedToDoByKey(
    SHIFT_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadRole = isAllowedToDoByKey(
    ROLE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  // ?? Check permission of employee management

  // Check create permission
  const isAllowedToCreate = false;

  // Check update permission
  const isAllowedToUpdate = isAllowedToDoByKey(
    EMPLOYEE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["update"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  // Check delete permission
  const isAllowedToDelete = isAllowedToDoByKey(
    EMPLOYEE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["delete"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  // Pass EmployeesViewManagement as a prop if isGeneralAccess is true
  if (isAllowedToCreate || isAllowedToUpdate || isAllowedToDelete) {
    const ManagementComponent = (
      <GeneralAccessManagement
        isAllowedToCreate={isAllowedToCreate}
        isAllowedToUpdate={isAllowedToUpdate}
        isAllowedToDelete={isAllowedToDelete}
        EmployeesViewManagement={SearchViewManagement}
      />
    );

    return !(
      isAllowedToReadDesignation &&
      isAllowedToReadTeam &&
      isAllowedToReadShift &&
      isAllowedToReadRole &&
      (isRoleAdmin || isRoleTeamWise)
    ) ? (
      <WarningAlert
        message="<p>In order to effectively manage the system, you need to have read permissions for <strong>Designation, Team, Shift, and Role management</strong>. If you are an administrator, you can enable these permissions from the role management section.</p>
          <hr/> <p class='mb-0'>If you need further assistance, please contact the developer at <a href='mailto:ankitbattersea@gmail.com' >ankitbattersea@gmail.com</a>.</p>"
      />
    ) : (
      ManagementComponent
    );
  } else {
    return <SearchViewManagement />;
  }

};

export default SearchManagement;